"use strict";

var get = require('lodash/get');

var set = require('lodash/set');

var snakeCase = require('lodash/snakeCase');

var startCase = require('lodash/startCase');

var Envelope = require('../../products/interfaces/Envelope');

var getComposables = require('../PrintingDetails/componentComposables');

var Inventory = require('./Inventory');

function inventoryEnvelopes(comps, date, options) {
  var components = comps.filter(function (comp) {
    return Object.prototype.isPrototypeOf.call(Envelope.prototype, comp);
  });
  var inventory = {};
  var componentSettings = options.printers.printingPlus.components;
  components.forEach(function (component) {
    var component_type = component.type;
    var component_options = componentSettings[component_type] || componentSettings["default"];
    var quantity = getComposables('envelopeQtyText', component_options.envelopeQtyText).reduce(function (accumulator, fn) {
      return fn(accumulator, {}, {}, component, component_options, options);
    }, 0);
    var envelopeType = getComposables('envelopeSizeText', component_options.envelopeSizeText).reduce(function (accumulator, fn) {
      return fn(accumulator, {}, {}, component, component_options, options);
    }, '');
    var paperType = getComposables('paperText', component_options.paperText).reduce(function (accumulator, fn) {
      return fn(accumulator, {}, {}, component, component_options, options);
    }, '');

    if (quantity && envelopeType && paperType) {
      var size;

      if (envelopeType.match(/A1/)) {
        size = 'A1';
      } else if (envelopeType.match(/A75/)) {
        size = 'A7.5';
      } else if (envelopeType.match(/A7/)) {
        size = 'A7';
      }

      if (envelopeType.match(/ungummed/i)) {
        size += ' Ungummed';
      }

      var sanitizedPaperType = startCase(paperType.toLowerCase());
      var key = [sanitizedPaperType, size].join(' ');

      if (get(inventory, [key])) {
        set(inventory, [key], get(inventory, [key]) + quantity);
      } else {
        set(inventory, [key], quantity);
      }
    }
  });
  return Object.keys(inventory).map(function (name) {
    return new Inventory({
      name: name,
      date: date,
      key: snakeCase(name),
      category: 'envelopes',
      unit: 'each',
      quantity: inventory[name]
    });
  });
}

module.exports = inventoryEnvelopes;